import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavItem } from '../../models/nav-item';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavDataService {
  private navData: NavItem[] = [
    {
        "url": "docs",
        "title": "Home",
        "tooltip": "Welcome to the Angular documentation set.",
        "hidden": false,
        "iconImage": "home",
        "route": "/home",
        children: [
          {
            title: 'Dashboard',
            iconImage: 'dashboard',
            route: '/home/dashboard',
            tooltip: 'Click to view Dashboard info'
          },
          {
            title: 'Argus',
            iconImage: 'view_module',
            route: '/home/argus',
            tooltip: 'Click to view Argus info'
          }
        ]
    },
    {
        "url": "docs",
        "title": "Data Vault",
        "tooltip": "Welcome to the Angular documentation set.",
        "hidden": false,
        "iconImage": "inventory_2",
        "route": "/vault"
    },
    // {
    //     "url": "docs",
    //     "title": "Prompts",
    //     "tooltip": "Prompts",
    //     "hidden": false,
    //     "iconImage": "chat",
    //     "route": "/prompt"
    // },
    // {
    //     "url": "docs",
    //     "title": "Ratings",
    //     "tooltip": "Welcome to the Angular documentation set.",
    //     "hidden": false,
    //     "iconImage": 'grading',
    //     "route": "/ratings",
    //     children: [
    //       {
    //         title: 'Liability',
    //         iconImage: 'gavel',
    //         route: '/ratings/liability',
    //         tooltip: 'Click to view liability'
    //       },
    //       {
    //         title: 'Allowance',
    //         iconImage: 'account_balance_wallet',
    //         route: 'ratings/allowance',
    //         tooltip: 'Click to view Allowance'
    //       },
    //       {
    //         title: 'Allowance Status',
    //         iconImage: 'rule',
    //         route: 'ratings/allowanceStatus',
    //         tooltip: 'Click to view Allowance'
    //       },
    //       {
    //         title: 'Appeal Savings',
    //         iconImage: 'savings',
    //         route: 'ratings/appealSavings',
    //         tooltip: 'Click to view Allowance'
    //       },
    //       {
    //         title: 'Appeal Status',
    //         iconImage: 'how_to_vote',
    //         route: 'ratings/appealStatus',
    //         tooltip: 'Click to view Allowance'
    //       },
    //       {
    //         title: 'Property Search',
    //         iconImage: 'travel_explore',
    //         route: 'ratings/propertySearch',
    //         tooltip: 'Click to view Allowance'
    //       }
    //     ]
    // },
  ];
  constructor(private http: HttpClient) {}

  getNavData(): Observable<NavItem[]> {
    return of(this.navData);
  }
}
